import React from 'react';
import InvestorMailboxBannerSC from './investor-mailbox-banner.styled';
import { HeadingTwo, BodyText } from '../typography';
import Button from '../ui/button';

import { FormattedMessage } from 'react-intl';
import dlt from '../../utils/default-lang';

const InvestorMailboxBanner = () => {
  const onEmailClick = () => {
    window.location = 'mailto:info@wishmaker.sk';
  };
  return (
    <InvestorMailboxBannerSC>
      <div className="left-wrap">
        <HeadingTwo className="white left-wrap--main-headline">
          <FormattedMessage id="menu_mailbox" defaultMessage={dlt['menu_mailbox']} />
        </HeadingTwo>
      </div>
      <div className="right-wrap">
        <BodyText className="grey bolder">
          <FormattedMessage id="global_contact_us" defaultMessage={dlt['global_contact_us']} />
        </BodyText>
        <Button type="LINK" onClick={() => onEmailClick()}>
          info@wishmaker.sk
        </Button>
      </div>
    </InvestorMailboxBannerSC>
  );
};

export default InvestorMailboxBanner;
